import { render } from "./AddUnitAndLesson.vue?vue&type=template&id=4b710c5a&scoped=true"
import script from "./AddUnitAndLesson.vue?vue&type=script&lang=js"
export * from "./AddUnitAndLesson.vue?vue&type=script&lang=js"

import "./AddUnitAndLesson.vue?vue&type=style&index=0&id=4b710c5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b710c5a"]])

export default __exports__